import { Component, OnInit, ViewChild } from '@angular/core';
import { UserInfo } from '../../service/Model/UserInfo';
import { TeilpaketKraft } from '../../service/Model/TeilpaketKraft';
import { SelectItem } from 'primeng/api';
import { DataTable } from 'primeng/primeng';
import { UserRole } from '../../type/UserRole';
import { UserinfoService } from '../../service/userinfo.service';
import { KraftpaketService } from '../../service/kraftpaket.service';
import { HistlistService } from '../../service/histlist.service';
import { CsvUploadService } from '../../service/csv-upload.service';
import { MatSnackBar } from '@angular/material';
import { UserData } from '../../../../config/globals/userData.global';
import { TeilpaketStatus } from '../types/TeilpaketStatus';

export enum PageModeEnum {
  'mpListe',
  'mpDetail',
  'mpUpload',
}

@Component({
  selector: 'app-massenberechnung-kraft',
  templateUrl: './app.massenberechnung.kraft.html',
  styleUrls: ['./app.massenberechnung.kraft.scss'],
})
export class AppMassenberechnungKraft implements OnInit {

  userinfo: UserInfo;

  //Buttonsteuerung
  id_origin : any;
  paketBearbeitungDisabled: boolean = true;
  paketBearbeitungDisabledPruefOk: boolean = true;
  paketBearbeitungDisabledInFreigabe: boolean = true;
  paketBearbeitungDisabledFreigegeben: boolean = true;
  paketLoeschenDisabled: boolean = true;
  importBtAnzeigen: boolean = false;
  loeschenBtAnzeigen: boolean = false;
  uebergabeBtAnzeigen: boolean = false;
  zuruecksendenBtAnzeigen: boolean = false;
  einspielenBtAnzeigen: boolean = false;
  ablehnenBtAnzeigen: boolean = false;
  freigebenBtAnzeigen: boolean = false;

  selectedTeilpaket: TeilpaketKraft;
  pageModes = PageModeEnum;
  mode: PageModeEnum = this.pageModes.mpListe;

  showHistList : boolean = false;
  displayDialog : boolean = false;
  deleteDialog: boolean = false;
  einspielenDialog: boolean = false;
  requestLog : any;
  statusAllList: SelectItem[];

  private _teilpakete: TeilpaketKraft[];
  private _teilpaketeMatLab: TeilpaketKraft[];
  @ViewChild(DataTable) _teilpaketDetails: DataTable;

  private readonly UserRole = UserRole; // necessary to be able use it in html-component

  setting = {
    element: {
      dynamicDownload: null as HTMLElement
    }
  }

  constructor(private userinfoService: UserinfoService,
              private kraftpakService: KraftpaketService,
              private HistListService: HistlistService,
              public csvUploadService: CsvUploadService,
              private snackBar: MatSnackBar,
              public userData : UserData) {
  }

  ngOnInit(): void {
    this.statusAllList = Object.values(TeilpaketStatus).map(val => <SelectItem> ({label: val, value: val}));

    this.userinfo = this.userinfoService.getUserinfo();
    if (this.userinfo.rolle == UserRole.MAKLER) {
      //Makler hat neben 'Teilpaket anezigen'-Button nur den Button 'Teilpaket übergeben'
      this.importBtAnzeigen = false;
      this.loeschenBtAnzeigen = true;
      this.uebergabeBtAnzeigen = true;
      this.zuruecksendenBtAnzeigen = false;
      this.einspielenBtAnzeigen = false;
      this.ablehnenBtAnzeigen = false;
      this.freigebenBtAnzeigen = false;
    }
    if (this.userinfo.rolle == UserRole.MAKLERBETREUER) {
      this.importBtAnzeigen = true;
      this.loeschenBtAnzeigen = true;
      this.uebergabeBtAnzeigen = true;
      this.zuruecksendenBtAnzeigen = false;
      this.einspielenBtAnzeigen = false;
      this.ablehnenBtAnzeigen = false;
      this.freigebenBtAnzeigen = false;
    }
    if (this.userinfo.rolle == UserRole.PRODUKTGEBER) {
      this.importBtAnzeigen = true;
      this.loeschenBtAnzeigen = false;
      this.uebergabeBtAnzeigen = false;
      this.zuruecksendenBtAnzeigen = true;
      this.einspielenBtAnzeigen = true;
      this.ablehnenBtAnzeigen = true;
      this.freigebenBtAnzeigen = true;
    }
    this.displayDialog = false;
    this.deleteDialog = false;
    this.einspielenDialog = false;
    //laden der Teilpakete
    this.mode = this.pageModes.mpListe;
  }

  importMaklerpaket(): void {
    this.mode = this.pageModes.mpUpload;
  }

  anzeigeMpliste() {
    console.log("Paketübersicht anzeigen");
    this.mode = this.pageModes.mpListe;
    this._teilpaketDetails = null;
  }

  uploadStatus(uploadStatus: any): void {
    if (uploadStatus.result.length > 0) {
      this._teilpaketDetails = uploadStatus.result;
      this.selectedTeilpaket = uploadStatus.newTeilpaket;
      this.mode = this.pageModes.mpDetail;
    } else {
      this.snackBar.open("Teilpaket-Details können nicht geladen werden!", null, {duration: 2000, panelClass: ["bgc-red-400"]});
      this.mode = this.pageModes.mpListe;
    }
  }

}
